import { defineMessages } from 'react-intl';

export default defineMessages({
  createGitIgnore: {
    id: 'frontbucket.repository.emptyState.createGitIgnore',
    description: 'Action to create a .gitignore',
    defaultMessage: 'Create a { ignoreFileName }',
  },
  createReadme: {
    id: 'frontbucket.repository.emptyState.createReadme',
    description: 'Action to create a README file',
    defaultMessage: 'Create a README',
  },
  getStartedHeader: {
    id: 'frontbucket.repository.emptyState.getStartedHeader',
    description:
      'Header for instructions for getting started with a new repository',
    defaultMessage: 'Get started quickly',
  },
  getStartedInstructions: {
    id: 'frontbucket.repository.emptyState.getStartedInstructions',
    description: 'Instructions for getting started with a new repository',
    defaultMessage:
      'Creating a README or a { ignoreFileName } is a quick and easy way to get something into your repository.',
  },
  header: {
    id: 'frontbucket.repository.emptyState.header',
    description: 'Header of the repository empty state screen',
    defaultMessage: `Let's put some bits in your bucket`,
  },
  localRepositoryHeaderGit: {
    id: 'frontbucket.repository.emptyState.localRepoHeaderGit',
    description:
      'Header for instructions for pushing local git code to a new repository',
    defaultMessage: 'Get your local Git repository on Bitbucket',
  },
  localRepositoryInstructionsStep1: {
    id: 'frontbucket.repository.emptyState.localRepositoryInstructionsStep1',
    description:
      'Step 1 of instructions for pushing local code to a new repository',
    defaultMessage: `Step 1: Switch to your repository's directory`,
  },
  localRepositoryInstructionsStep2: {
    id: 'frontbucket.repository.emptyState.localRepositoryInstructionsStep2',
    description:
      'Step 2 of instructions for pushing local code to a new repository',
    defaultMessage: 'Step 2: Connect your existing repository to Bitbucket',
  },
  localRepositoryInstructionsStep3: {
    id: 'frontbucket.repository.emptyState.localRepositoryInstructionsStep3',
    description:
      'Step 3 of instructions for pushing local code to a new repository',
    defaultMessage: `Step 3: Update the default field of the repository's .hgrc file with its new url`,
  },
  localRepositoryInstructionsMoreInfo: {
    id: 'frontbucket.repository.emptyState.localRepositoryInstructionsMoreInfo',
    description: 'Message with more help for pushing a local repository',
    defaultMessage: `Need more information? { learnHowLink }`,
  },
  localRepositoryInstructionsLearnMoreLink: {
    id: 'frontbucket.repository.emptyState.localRepositoryInstructionsLearnMoreLink',
    description: 'Link text for documentation on pushing a local repository',
    defaultMessage: `Learn more`,
  },
});
